<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-9">
          <div class="media align-items-center">
            <img
              class="rounded-circle user-image border mr-2"
              :src="getPhoto(company.logo,'thumbnailCropped')"
              alt=""
              style="width: 60px"
            >
            <div class="about">
              <div class="name f-w-600">
                {{ company.name }} {{ getCompanyFormat(company.format) }}
              </div>
              <div class="status">
                {{ company.taxId }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 text-right">
          <b-dropdown
            dropleft
            no-caret
            menu-class="dropdown-content"
            variant="link"
          >
            <template #button-content>
              <feather
                type="menu"
                size="16"
                class="text-dark"
              />
            </template>
            <b-dropdown-item @click.prevent="changePosition">
              <feather
                type="edit-2"
                size="12"
              />
              {{ $t('dashboardActiveCompanyCard.vzifmiDyi') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="company.legalForm !=='PERSONAL'"
              @click.prevent="leaveCompany"
            >
              <feather
                type="trash"
                size="12"
              />
              {{ $t('dashboardActiveCompanyCard.profilimiSil', {getProfileName: getProfileName(profile)}) }}
            </b-dropdown-item>
            <b-dropdown-item :to="{name: 'changeAccount' }">
              <feather
                type="git-pull-request"
                size="12"
              />
              {{ $t('dashboardActiveCompanyCard.aktivProfiliDyi') }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>

      <p class="mt-2">
        {{
          $t('dashboardActiveCompanyCard.sizHazrdaIrktind', {
            name: company.name,
            getCompanyFormat: getCompanyFormat(company.format)
          })
        }}
        <strong> {{ getProfileName(profile) }} </strong> {{ $t('dashboardActiveCompanyCard.profilid') }}
        <strong>{{ position }}</strong>
        {{ $t('dashboardActiveCompanyCard.vzifsindFaliyytGstrirsiniz') }}
      </p>
      <UserCompanyAdminDetails class="mb-3" />
      <UserPackageStatusView />

      <div
        v-if="hasExtraPurchasablePackage && isAdmin && profile === 'PROCUREMENT'"
        class="mt-3"
      >
        <div
          class="alert alert-primary"
          @click="$router.push({name: 'addOnPage'})"
        >
          {{ $t('dashboardActiveCompanyCard.irktinizN') }} <strong>{{ packageName }}</strong>
          {{ $t('dashboardActiveCompanyCard.paketiniAlaBilrsiniz') }}
        </div>
      </div>
      <div
        v-else-if="!hasExtraPurchasablePackage && isAdmin && profile === 'PROCUREMENT'"
        class="mt-3"
      >
        <div
          class="alert alert-primary"
          @click="$router.push({name: 'addOnPage'})"
        >
          {{ $t('dashboardActiveCompanyCard.irktinizN') }} <strong>{{ packageName }}</strong>
          {{ $t('dashboardActiveCompanyCard.aktivdi') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserCompanyAdminDetails from "@/pages/scc/account/UserCompanyAdminDetails.vue"
import UserPackageStatusView from "@/pages/scc/account/UserPackageStatusView.vue"
import {changePosition, getPackages, leaveCompanyProfile} from "@/repositories/GeneralDataRepository";
import {getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";
import {mapState} from "vuex";

export default {
  name: 'DashboardActiveCompanyCard',
  components: {UserCompanyAdminDetails, UserPackageStatusView},
  props: {
    company: {},
    position: {},
    profile: {}
  },
  data() {
    return {
      packageName: "",
      hasExtraPurchasablePackage: false,
      activePackage: null,
      packages: []
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      isAdmin: state => state.auth.isAdmin
    })
  },

  mounted() {
    this.checkCompanyPackage();
  },
  methods: {


    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    getProfileName(keyword) {
      return getProfileName(keyword,this.$i18n);
    },
    changePosition() {

      this.$swal({
        title: this.$t("dashboardActiveCompanyCard.vezife"),
        input: 'text',
        icon: 'question',
        inputValue: this.position,
      }).then((result) => {

        if (result.value) {
          changePosition(this.token, result.value).then(data => {
            if (data.code === 200) {

              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("dashboardActiveCompanyCard.vezifeOK"),
                icon: 'success'
              }).then(() => {
                this.$store.dispatch('auth/setPosition', result.value);
              })

            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          })
        }

      })

    },


    leaveCompany() {

      if (confirm(this.$t("dashboardActiveCompanyCard.silmekEmin"))) {

        leaveCompanyProfile(this.token).then(data => {

          if (data.code === 200) {
            window.location.reload();
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            }).then(() => {
              window.location.reload();
            })
          }

        })

      }

    },

    checkCompanyPackage() {
      getPackages(this.token, 'addon').then(({code, packages, activePackage}) => {
        if (code === 200) {

          this.activePackage = activePackage;
          if (packages.length > 0) {
            this.packages = packages;
            this.packageName = packages[0].package.name;
            if (activePackage === null || activePackage.status === 'EXPIRED') {
              this.hasExtraPurchasablePackage = true;
            }

          }

        }
      })
    }

  }
}
</script>
<style scoped>

@keyframes blink {
  50% {
    opacity: 0.2;
  }
}

@-webkit-keyframes blink {
  50% {
    opacity: 0.2;
  }
}

</style>
